import request from '@/utils/request'

export function fetchCardGroupBatchList (query) {
  return request({
    url: '/card/api/card_group_batch/index',
    method: 'get',
    params: query
  })
}

export function fetchCardBatch (id) {
  return request({
    url: '/card/api/card_group_batch/view',
    method: 'get',
    params: { id }
  })
}

export function createCardGroupBatch (data) {
  return request({
    url: '/card/api/card_group_batch/insert',
    method: 'post',
    data
  })
}

export function updateCardGroupBatch (id, data) {
  return request({
    url: '/card/api/card_group_batch/update',
    method: 'post',
    params: { id },
    data
  })
}

export function deleteCardGroupBatch (id) {
  return request({
    url: '/card/api/card_group_batch/delete',
    method: 'post',
    params: { id }
  })
}

export function batchCards (id, page, limit) {
  return request({
    url: '/card/api/card_group_batch/cards',
    method: 'get',
    params: {id: id, page: page, limit: limit}
  })
}

export function batchUpdateKind (id, kind) {
  return request({
    url: '/card/api/card_group_batch/kind',
    method: 'post',
    params: {id, kind}
  })
}

export function batchUpdateKfUrl (id, url) {
  return request({
    url: '/card/api/card_group_batch/kfUrl',
    method: 'post',
    params: {id, url}
  })
}

export function batchUpdateSpec (id, spec) {
  return request({
    url: '/card/api/card_group_batch/spec',
    method: 'post',
    params: {id, spec}
  })
}

export function batchUpdateRechargeUrl (id, url) {
  return request({
    url: '/card/api/card_group_batch/rechargeUrl',
    method: 'post',
    params: {id, url}
  })
}

export function batchUpdateCatelog (id, catelog) {
  return request({
    url: '/card/api/card_group_batch/catelog',
    method: 'post',
    params: {id, catelog}
  })
}

export function updateWechatApp (id, appId) {
  return request({
    url: '/card/api/card_group_batch/setApp',
    method: 'post',
    params: {id, appId}
  })
}

export function updateActive (id, active) {
  return request({
    url: '/card/api/card_group_batch/setActive',
    method: 'post',
    params: {id, active}
  })
}

export function updateSalesChannel (id, data) {
  return request({
    url: '/card/api/card_group_batch/salesChannel',
    method: 'post',
    params: { id },
    data
  })
}

export function cleanUserInfo (data) {
  return request({
    url: '/card/api/card_group_batch/cleanUserInfo',
    method: 'post',
    params: data
  })
}

export function cleanOrder (data) {
  return request({
    url: '/card/api/card_group_batch/cleanOrder',
    method: 'post',
    params: data
  })
}

export function cleanCert (data) {
  return request({
    url: '/card/api/card_group_batch/cleanCert',
    method: 'post',
    params: data
  })
}

export function cleanSales (id) {
  return request({
    url: '/card/api/card_group_batch/cleanSales',
    method: 'post',
    params: { id }
  })
}

export function batchUpdateSupplier (id, supplierId) {
  return request({
    url: '/card/api/card_group_batch/updateSupplier',
    method: 'post',
    params: { id, supplierId }
  })
}

export function batchUpdateView (id, viewId) {
  return request({
    url: '/card/api/card_group_batch/updateView',
    method: 'post',
    params: { id, viewId }
  })
}

export function batchUpdateAppId (id, appId) {
  return request({
    url: '/card/api/card_group_batch/updateAppId',
    method: 'post',
    params: { id, appId }
  })
}
export function exportApply (query) {
  return request({
    url: '/card/api/card_group_batch/export',
    method: 'get',
    params: query
  })
}

export function exportCardApply (query) {
  return request({
    url: '/card/api/card_group_batch/exportCard',
    method: 'get',
    params: query
  })
}

export function unbindBatch (id) {
  return request({
    url: '/card/api/card_group_batch/unbindBatch',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/card-group-batch.js